import React, { useState, useEffect } from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { newsService, reportsService, civilService } from "../services/api";

const COLORS = ["#1A5C2A", "#1565C0", "#E65100", "#6A1B9A", "#C62828"];

export default function StatsPage() {
  const [stats, setStats] = useState({ posts: 0, reports: 0, civil: 0, resolved: 0 });
  const [reportsByCategory, setReportsByCategory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      newsService.getPosts({ per_page: 100 }),
      reportsService.getReports(),
      civilService.getRequests(),
    ]).then(([posts, reports, civil]) => {
      const r = reports.data || [];
      const cats = {};
      r.forEach(rep => { cats[rep.category] = (cats[rep.category] || 0) + 1; });
      setReportsByCategory(Object.entries(cats).map(([name, value]) => ({ name, value })));
      setStats({
        posts: posts.data.count || 0,
        reports: r.length,
        civil: civil.data.length,
        resolved: r.filter(rep => rep.status === 'resolved').length,
      });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const activityData = [
    { name: 'Lun', signalements: 4, demandes: 2 },
    { name: 'Mar', signalements: 6, demandes: 3 },
    { name: 'Mer', signalements: 3, demandes: 5 },
    { name: 'Jeu', signalements: 8, demandes: 1 },
    { name: 'Ven', signalements: 5, demandes: 4 },
    { name: 'Sam', signalements: 2, demandes: 2 },
    { name: 'Dim', signalements: 1, demandes: 0 },
  ];

  if (loading) return <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Chargement...</div>;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Statistiques</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>Vue d ensemble de l activite municipale</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 24 }}>
        {[
          { label: "Actualites", value: stats.posts, color: "#1A5C2A", icon: "📰" },
          { label: "Signalements", value: stats.reports, color: "#6A1B9A", icon: "📋" },
          { label: "Demandes Civil", value: stats.civil, color: "#1565C0", icon: "📁" },
          { label: "Resolus", value: stats.resolved, color: "#E65100", icon: "✅" },
        ].map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderTop: `4px solid ${s.color}` }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>{s.icon}</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: "#1A1A2E" }}>{s.value}</div>
            <div style={{ fontSize: 13, color: "#8A8A9A" }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
          <h3 style={{ color: "#1A1A2E", fontSize: 16, fontWeight: 700, margin: "0 0 20px" }}>Activite cette semaine</h3>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={activityData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F5F6FA" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Bar dataKey="signalements" fill="#1A5C2A" radius={[4,4,0,0]} name="Signalements" />
              <Bar dataKey="demandes" fill="#1565C0" radius={[4,4,0,0]} name="Demandes" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
          <h3 style={{ color: "#1A1A2E", fontSize: 16, fontWeight: 700, margin: "0 0 20px" }}>Signalements par categorie</h3>
          {reportsByCategory.length === 0 ? (
            <div style={{ textAlign: "center", padding: 40, color: "#8A8A9A" }}>Aucun signalement</div>
          ) : (
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie data={reportsByCategory} cx="50%" cy="50%" innerRadius={50} outerRadius={80} dataKey="value" label={({ name, value }) => `${name}: ${value}`}>
                  {reportsByCategory.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}
